
const Btn_loader = ({ CustomeStyle }) => {
    return (
        <div className="w-full h-full flex items-center group">
            <div className="dot-wave mx-auto">
                {[1, 2, 3, 4].map((item) => {
                    return <div key={item} className={`dot-wave__dot ${CustomeStyle}`}></div>
                })}
            </div>
        </div>
    )
}

export default Btn_loader